<template>

  <div class="board">
    <base-header class="pb-6" type>
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <page-title icon="ni ni-tv-2" main="Painéis" sub="Geral" :help="true" titleHelp="Ajuda - Painéis"
            content="Página do painel Geral."></page-title>
        </div>
      </div>

      <div class="col-0">
        <card class="col-12">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Filtros</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Configure quais dados deverão ser listados no painel geral:
              </h6>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-md-5">
              <label class="form-control-label">Empresa</label>
              <base-input>
                <el-select
                  v-model="enterprise"
                  label="Selecione uma ou mais empresas"
                  collapse-tags
                  filterable
                  multiple
                  placeholder="Selecione uma ou mais empresas">
                  <el-option
                    v-for="item in enterprises"
                    name="item"
                    :key="item.codi_emp"
                    :label="item.iden_emp"
                    :value="item.codi_emp"
                    :block-keys="['Tab', 'Enter']">
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-12 col-md-5">
              <label class="form-control-label">Meta</label>
              <base-input>
                <el-select
                  v-model="category"
                  collapse-tags
                  filterable
                  multiple
                  placeholder="Selecione uma ou mais metas"
                >
                  <el-option
                    v-for="item in filterCard"
                    name="item"
                    :key="item"
                    :label="translateFilterCardValue(item)"
                    :value="item"
                     @close="onTouch('type')"
                    :block-keys="['Tab', 'Enter']"
                  />
                </el-select>
              </base-input>
            </div>
            <div class="col-12 col-md-2 mb-2" v-if="admin">
              <label class="form-control-label mb-3">Filtrar por Usuário?</label>
              <base-switch
                v-model="filterUser"
                :label="filterUser ? 'Sim' : 'Não'"
              />
            </div>

            <!-- User filters -->
            <div class="col-12 col-md-4" v-if="filterUser">
              <!-- <label class="form-control-label">Ano Safra</label>
              <multiselect
                v-loading="loading.anosafras"
                v-model="anosafra"
                :options="anosafras || []"
                label="descricao"
                track-by="id"
                placeholder="Selecionar ano safra"
                @change="getAnosafras"
              /> -->
              <anosafra-multiselect
                v-loading="loading.anosafras"
                v-model="anosafra"
                label="Ano Safra"
              />
            </div>
            <div class="col-12 col-md-4" v-if="filterUser">
              <label class="form-control-label">Cargo</label>
              <multiselect
                v-loading="loading.roles"
                v-model="role"
                :options="roles || []"
                placeholder="Selecionar cargo"
              />
            </div>
            <div class="col-12 col-md-4 mb-3" v-if="filterUser">
              <label class="form-control-label">Usuário</label>
              <multiselect
                v-loading="loading.users"
                v-model="user"
                :options="users"
                placeholder="Nome do Usuário"
                label="name"
                track-by="id"
              />
            </div>
            
            <!-- Filter Actions -->
            <div class="col-12 justify-content-end">
              <div class="row justify-content-md-end justify-content-center">
                <base-button type="secondary" style="width: 9rem; max-height: 3rem;"  @click="clearAndSubmit()" class="ml-2 mb-2">Limpar filtros</base-button>
                <base-button type="primary"   style="width: 9rem; max-height: 3rem;"  @click="ON_SUBMIT()"      class="ml-2 mb-2" :disabled="disabled">Filtrar</base-button>
              </div>
            </div>
          </div>
        </card>
      </div>

      <div class="row" v-loading="loadChartData">
        <div
          v-for="(grupo, index) in getSelectionCard"
          :key="index"
          class="col-12 col-md-6 col-xl-4"
        >
          <meta-vegetal
            :index="index"
            :grupo="grupo"
            :goals="goals"
            :realizedSales="realizedSales"
            :strategic-goals="strategicGoals"
            :realized-financial-goal="realized_financial_goal"
            :realized-strategic-goal="realized_strategic_goal"
            :strategic-total-vegetal="strategicTotalVegetal"
            :total-vegetal-supplier="totalGoalsVegetalSupplier"
            :realized-purchase-supplier-goal="realizedPurchaseSupplierGoal"
            :total-goals-purchase-supplier="totalVegetalSupplier"
            :all-sales-value="allSalesValue"
            :highlighted="index === 'meta_estrategica' || index === 'meta_financeira'"
            :admin="admin"
          />
        </div>
        <div
          v-for="(grupoStrategic, indexStrategic) in strategicGoals"
          :key="indexStrategic"
          class="col-12 col-md-6 col-xl-4"
        >
          <meta-vegetal
            :index="'ESTRATÉGICO ' + indexStrategic"
            :realizedSales="realizedSales"
            :grupo="grupoStrategic.salesman_goal"
            :goals="goals"
            :strategic-goals="strategicGoals"
            :realized-financial-goal="grupoStrategic.salesman_sales"
            :all-sales-value="allSalesValue"
            :strategic-total-vegetal="strategicTotalVegetal"
            :realized-strategic-goal="grupoStrategic.salesman_sales"
            :highlighted="index === 'meta_financeira'"
            :total-vegetal-supplier="totalVegetalSupplier"
          />
        </div>
      </div>
    </base-header>
    <!--Lists-->
    <div class="card-deck flex-column flex-xl-row">
      <!-- Members list group card -->
      <!-- Checklist -->
      <general-members-list
        v-if="$can('index', 'user')"
        :show-search="false"
      />
      <general-task-list v-if="$can('index', 'schedules')"/>
      <events-birthday v-if="$can('index', 'user')" />
      <!-- Progress track -->
    </div>
    <!--End lists-->
  </div>
</template>
<script>

import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import DoughnutChart from "@/components/Charts/DoughnutChart";

// Components
import BaseHeader from "@/components/BaseHeader";
import BaseProgress from "@/components/BaseProgress";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import PageTitle from "@/layouts/PageTitle";
import EventsBirthday from "@/views/Widgets/EventsBirthday";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
import PercentageBar from "@/components/Percentage/PercentageBar"
import MetaVegetal from "@/components/Cards/MetaVegetal.vue"
import BaseSwitch from '@/components/BaseSwitch';

import { Select, Option } from "element-ui";

// Lists
import GeneralMembersList from "@/views/Widgets/GeneralMembersList";
import GeneralTaskList from "@/views/Widgets/GeneralTaskList";

// Tables
import VectorMapCard from "@/views/Widgets/VectorMapCard";
import AverageTicketCard from "@/components/AverageTicketCard.vue";
import AbcCurveCard from "@/components/AbcCurveCard.vue";
import VegetalSalesRank from "../../components/VegetalSalesRank.vue";

export default {
  components: {
    VegetalSalesRank,
    LineChart,
    BarChart,
    BaseHeader,
    BaseProgress,
    BaseSwitch, 
    RouteBreadCrumb,
    StatsCard,
    GeneralTaskList,
    EventsBirthday,
    VectorMapCard,
    GeneralMembersList,
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [Select.name]: Select,
    [Option.name]: Option,
    PercentageBar,
    [DoughnutChart.name]: DoughnutChart,
    MetaVegetal,
    AverageTicketCard,
    AbcCurveCard
  },
  props: ["chartData", "options", "id", "draggable"],
  data() {
    return {
      totalGoalsVegetalSupplier: 0,
      realizedPurchaseSupplierGoal: 0, 
      loadChartData: false,
      allSalesValue: 0,
      renderChart: false,
      clients: [],
      category: [],
      filterUser: false,
      role: null,
      roles: ['Vendedor', 'Gerente Comercial', 'Coordenador'],
      user: null,
      users: [],
      anosafras: [],
      anosafra: {},
      filteredCategory: [],
      categories:[],
      enterprises:[],
      enterprise: [],
      manager: false,
      salesman: false,
      currentAnoSafra: {},
      newDashboard: {},
      filterCard:[],
      filteredClientsArea: [],
      financialGoal: Number,
      financialPercent: "",
      goalsValue:[],
      strategicGoal: Number,
      totalGoalsValues: {},
      totalVegetalGoals: {},
      strategicTotalVegetal: 0,
      totalVegetalSupplier: 0,
      goals: {},
      realizedSales: {},
      strategicGoals: {},
      salesman_type: "",
      loadedSalesmenType: "",
      redBarChart: {
        chartData: {
          labels: ["Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
          datasets: [
            {
              label: "Sales",
              data: [25, 20, 30, 22, 17, 29],
            },
          ],
        },
      },
      loading: {
        roles: false,
        users: false,
        anosafras: false
      },
    };
  },
  mounted() {
    this.salesman = this.$currentUser().is_salesman
    this.manager = this.$currentUser().is_manager
    this.setUserDashboard()
    this.checkExpiredPassword()
    if (this.$currentUser().is_salesman && !this.$currentUser().is_manager)
      this.getSalesmenType();
    this.getGoalsPercentage();
    this.getGoalsSupplier();
    this.getGoalsPurchaseSupplier()
    this.getRealizedSales();
    this.financialPercentage();
    this.getAllRealizedSales();
    this.getEnterprises();
    this.getGoalsValues()
  },
  methods: {
    checkExpiredPassword() {
      const userSignedIn = localStorage.getItem("currentUser");
      let newJson        = JSON.parse(userSignedIn);

      if (newJson.sign_in_count == 1) {
        newJson.sign_in_count = newJson.sign_in_count + 1;
        newJson = JSON.stringify(newJson);
        localStorage.setItem("currentUser", newJson);
        this.$toasted.global.defaultWarnig({
          msg: "Por gentileza insira uma nova senha",
        });
        this.$router.push("/expired_password");
      }

      let currentDate     = Date.now();
      let passwordDate    = newJson.password_changed_at;
      let passwordChanged = Date.parse(passwordDate);
      let lastUpdateInPassword = currentDate - passwordChanged;
      const expirableTime = 7791090221;

      if (lastUpdateInPassword < expirableTime) return;

      newJson.password_changed_at = new Date().toISOString();
      newJson = JSON.stringify(newJson);
      localStorage.setItem("currentUser", newJson);
      this.$toasted.global.defaultWarnig({
        msg: "Sua senha expirou, por gentileza insira uma nova senha",
      });

      this.$router.push("/expired_password");
    },
    clearFilter() {
      this.enterprise = []
      this.category = []
      this.anosafra = this.anosafra,
      this.role = null,
      this.user = null,
      this.saveUserDashboard()
    },
    clearAndSubmit() {
      this.clearFilter()
      this.saveUserDashboard()
      this.ON_SUBMIT()
    },
    async getManagers(query) {
      this.loading.users = true;
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      };
      console.log(this.anosafra);
      
      if (this.anosafra && this.anosafra.id)
        data.q["anosafra_id"] = this.anosafra.id;
      this.$http.secured.get("/api/v1/users", { params: data }).then((response) => {
        this.users = response.data.users
        this.loading.users = false;
      })
    },
   async getSalesmens(query) {
     this.loading.users = true;
      var data = {
        q: { name: query, is_salesman: true, status: this.active },
      };
      if (this.anosafra && this.anosafra.id)
        data.q["anosafra_id"] = this.anosafra.id;
      this.$http.secured.get("/api/v1/users", { params: data }).then((response) => {
        this.users = response.data.users || []
        this.loading.users = false;
      })
    },
    async getCoordinator(query) {
      this.loading.users = true;
      var data = {
        q: { name: query, is_coordinator: true, status: this.active },
      };
      if (this.anosafra && this.anosafra.id)
        data.q["anosafra_id"] = this.anosafra.id;
      this.$http.secured
        .get("/api/v1/users", { params: data })
        .then((response) => {
          this.users = response.data.users
          this.loading.users = false;
        })
    },
    getEnterprises(q = "") {
      this.isLoadingEnterprise = true;
      this.$http.secured
        .get("/api/v1/report/enterprise_data", {
          params: { q: { iden_emp: q, situ_emp: "A" } },
        })
        .then((response) => {
          this.isLoadingEnterprise = false;
          this.enterprises = response.data;
          this.enterprises.shift();
          this.enterprises.shift();
        })
        .catch(() => {
          this.$toasted.global.defaultWarnig({ msg: "Empresas não encontradas"})
          this.isLoadingEnterprise = false;
        });
    },
    ON_SUBMIT() {
      this.filteredCategory = this.category
      this.getGoalsPercentage();

      if (this.filterUser) {
        this.getRealizedSales();
      } else {
        this.getAllRealizedSales();
      }

      this.getGoalsValues();
      this.getGoalsPurchaseSupplier()
    },
    async getGoalsValues() {
      this.loadChartData = true

      console.log('[getGoalsValues][this.anosafra.id]', this.anosafras.id);
      
      try {
        const params = {
          anosafra_id: this.filterUser ? this.anosafra.id : this.currentAnoSafra.id,
          silenceAlert: true,
          enterprise_id: this.enterprise.length ? this.enterprise : null
        };

        if (this.$currentUser().is_admin && this.filterUser) {
          if (this.role == 'Vendedor') {
            params["salesman_id"]  = this.user.id;
            params["salesman_job"] = "Vendedores";
          }
          else if (this.role == 'Gerente Comercial' || this.role == 'Coordenador') {
            params["salesman_id"]  = this.user.id;
            params["salesman_job"] = "Gestores";
          } else {
            params["salesman_id"]  = this.$currentUser().id;
            params["salesman_job"] = "Vegetal";
          }
        } else if (this.$currentUser().is_admin) {
          params["salesman_id"] = 0
        } else if (this.$currentUser().is_manager) {
          params["salesman_id"]  = this.$currentUser().id;
          params["salesman_job"] = "Gestores";
        } else {
          params["salesman_id"]  = this.$currentUser().id;
          params["salesman_job"] = "Vendedores";
        }

        const response = await this.$http.secured.get("/api/v1/totalvalues", { params });

        this.totalVegetalGoals = response.data;
        this.totalGoalsValues  = response.data;

        this.filterCard = Object.keys(response.data || {});
        if (!this.admin) {
          this.filterCard = this.filterCard.filter(key => key !== "meta_estrategica" && key !== "meta_fornecedor");
        }
        this.financialGoal = response.data["meta_financeira"];
        this.strategicGoal = response.data["meta_estrategica"];
      } catch (error) {
        console.log("[General][getGoalsValues]", error)
      }

      this.loadChartData = false
    },
    async getGoalsPercentage() {
      const data = {
        "goal[salesmen_type]": this.salesman_type,
        "goal[dashboard]": true,
        "goal[anosafra_id]": this.filterUser ? this.anosafra.id : this.currentAnoSafra.id,
        silenceAlert: true,
        enterprise_id: this.enterprise.length ? this.enterprise : null
      };

      if (this.$currentUser().is_admin) {
        if (this.user && (this.user.is_coordinator || this.user.is_manager)) {
          data["goal[manager_id]"] = this.user.id;
        } else if (this.user && this.user.is_salesman) {
          data["goal[salesman_id]"] = this.user.id;
        }
      } else if (this.$currentUser().is_manager) {
        data["goal[manager_id]"] = this.$currentUser().id;
      } else {
        data["goal[salesman_id]"] = this.$currentUser().id;
      }

      try {
        const response      = await this.$http.secured.get("/api/v1/report/goals", { params: data })
        const salesmenData  = response.data;

        const goals          = {}
        const strategicGoals = {}

        salesmenData.forEach((salesmanData) => {
          salesmanData.goals.goal.forEach((group, index) => {
            const groupName = group.group

            goals[groupName]                          = goals[groupName] || { salesman_sales: 0, salesman_goal: 0 };
            strategicGoals[groupName]                 = strategicGoals[groupName] || { salesman_sales: 0, salesman_goal: 0 };

            goals[groupName].salesman_sales           += group.salesman_sales || 0;
            goals[groupName].salesman_goal            += group.salesman_goal || 0;
            strategicGoals[groupName].salesman_sales  += salesmanData.goals.strategic_goal[index].salesman_sales || 0;
            strategicGoals[groupName].salesman_goal   += salesmanData.goals.strategic_goal[index].salesman_goal || 0;
          })
        });

        let strategicSales = 0;

        Object.values(strategicGoals).forEach((goal) => {
           strategicSales += (goal.salesman_sales || 0);
        });

        this.goals                 = goals
        this.strategicGoals        = strategicGoals
        this.strategicTotalVegetal = strategicSales;

      } catch(error) {
        console.error("[General] getGoalsPercentage", error)
      }
    },
    async getGoalsPurchaseSupplier() {
      try {
        const { data } = await this.$http.secured.get("/api/v2/supplier_purchase_goals/goals_supplier", {
          params: {
            enterprise_id: this.enterprise.length ? this.enterprise : null
          }
        });

        this.realizedPurchaseSupplierGoal = data.goal_purchase_realized;
        this.totalGoalsVegetalSupplier = data.total_purchases_supplier;

      } catch (error) {
        console.error("Erro ao obter metas de compras do fornecedor:", error);
      }
    },
    async getGoalsSupplier() {
      const data = { q: { anosafra_id: this.$store.state.currentAnosafra.id } };

      if (this.$currentUser().is_admin) {
      } else if (this.$currentUser().is_manager) {
        data["goal[manager_id]"] = this.$currentUser().id;
      } else {
        data["goal[salesman_id]"] = this.$currentUser().id;
      }

      try {
        const { data } = await this.$http.secured.get("/api/v1/report/supplier_purchase_goals", { params: { service_params: data } })
        let totalMetaSupplier = 0;
  
        for (const supplier in data) {
          if (data.hasOwnProperty(supplier)) {
            data[supplier].forEach(item => {
              totalMetaSupplier += parseFloat(item.meta_fornec) || 0;
            });
          }
        }

        this.totalVegetalSupplier = totalMetaSupplier || 0;
      } catch (error) {
        console.error("[General][vegetalGoal]", error);
      }
    },
    async getRealizedSales() {
      const data = {
        "goal[salesmen_type]": this.salesman_type,
        silenceAlert: true,
        anosafra_id: this.filterUser ? this.anosafra.id : this.currentAnoSafra.id,
        // all_sales_value: true,
        enterprise_id: this.enterprise.length ? this.enterprise : null
      };

      if (this.$currentUser().is_admin && this.filterUser) {
        if (this.role == 'Vendedor') {
          data["goal[salesman_id]"] = this.user.id;
        }
        else if (this.role == 'Gerente Comercial' || this.role == 'Coordenador') {
          data["goal[manager_id]"] = this.user.id;
        } else {
          data["goal[admin_id]"] = this.$currentUser().id;
        }
      } else if (this.$currentUser().is_admin) {
      } else if (this.$currentUser().is_manager) {
        data["goal[manager_id]"] = this.$currentUser().id;
      } else {
        data["goal[salesman_id]"] = this.$currentUser().id;
      }

      try {
        const response = await this.$http.secured.get("/api/v1/report/realized_financial_goals", { params: data })
        const newRealizedSales = {};
        response.data.realized_financial.forEach((e) => (newRealizedSales[e.group] = e));
        this.realizedSales = newRealizedSales;
      } catch (error) {
        console.error("[General][getRealizedSales]", error);
      }
    },
    getAllRealizedSales() {
      const data = {
        silenceAlert: true,
        anosafra_id: this.currentAnoSafra.id,
        all_sales_value: true,
        enterprise_id: this.enterprise.length ? this.enterprise : null
      };

      this.$http.secured
        .get("/api/v1/report/realized_financial_goals", { params: data })
        .then((response) => {
          this.allSalesValue = response.data || 0
        })
        .catch((error) => {
          console.error("[General][getAllRealizedSales]", error);
        });
    },
    async getSalesmenType(user) {
      this.loadChartData = true

      try {
        const response = await this.$http.secured.get(`/api/v1/anosafra_user`, {
          params: {
            q: {
              salesman_id: this.$currentUser().id,
              anosafra_id: this.currentAnoSafra.id,
            },
            silenceAlert: true,
          },
        });
        this.salesman_type = response.data.anosafra_users[0].salesman_type;
        this.loadedSalesmenType = true;
      } catch (error) {
        console.error("[General][getSalesmenType]", error);
      }

      this.loadChartData = false
    },
    onTouch (campo) {
      switch(campo) {
        case 'type':
          this.isTouchedType = true;
          break;
      }
    },
    setUserDashboard() {
      try {
        this.category   = this.$currentUser().dashboard_order.length > 0 ? this.$currentUser().dashboard_order : []
        this.enterprise = this.$currentUser().dashboard_enterprises === null ? [] : this.$currentUser().dashboard_enterprises
      } catch (error) {
        console.error("[General][setUserDashboard]", error)
      }
    },
    saveUserDashboard() {
      this.$http.secured
        .put(`/api/v1/users/${this.$currentUser().id}`, { user: { dashboard_order: this.category, dashboard_enterprises: this.enterprise} })
        .then((response) => {
          let currentUser = JSON.parse(localStorage.getItem("currentUser"))
          currentUser.dashboard_order = this.category
          currentUser.dashboard_enterprises = this.enterprise
          currentUser = JSON.stringify(currentUser)
          localStorage.setItem("currentUser", currentUser)
        })
        .catch((error) => console.log(error));
    },
    financialPercentage() {
      this.financialPercent =
        (this.financialGoal.length / this.strategicGoal.length) * 100;

      this.goals[0] = this.financialPercent.toFixed(2);
    },
    checkTypeUser() {
      if (this.role == "Vendedor")
        this.getSalesmens('')
      if (this.role == "Gerente Comercial")
        this.getManagers('')
      if (this.role == "Coordenador")
        this.getCoordinator('')
    },
    translateFilterCardValue(value) {
      if (value === "meta_financeira")  return "META VEGETAL";
      if (value === "meta_estrategica") return "META ESTRATÉGICA";
      if (value === "meta_fornecedor") return "META FORNECEDOR";

      return value;
    },
  },
  computed: {
    admin() {
      if (!this.$currentUser()) return false;

      return !!this.$currentUser().is_admin;
    },
    disabled() {
      const isEmpty = (field) => field == null || field.length == 0;
      if (this.filterUser) {
        return [this.anosafra, this.role, this.user].some(isEmpty);
      } else {
        return [this.enterprise, this.category].every(isEmpty);
      }
    },
    realized_financial_goal() {
      return Object.values(this.goals).reduce(
        (sum, current) => sum + (current.salesman_sales || 0),
        0
      );
    },
    realized_sales() {
      return Object.values(this.realizedSales).reduce(
        (sum, current) => sum + (current.salesman_sales || 0),
        0
      );
    },
    realized_strategic_goal() {
      return Object.values(this.strategicGoals).reduce(
        (sum, current) => sum + (current.salesman_sales || 0),
        0
      );
    },
    getSelectionCard() {
      if (this.admin) return this.selectionCard;
      return this.filteredSelectionCard;
    },
    selectionCard() {
      if (!this.filteredCategory.length) return this.totalGoalsValues
      let obj = {}
      this.filteredCategory.map(el => { obj[el] = this.totalGoalsValues[el]} )
      return obj
    },
    filteredSelectionCard() {
      const filtered = Object.fromEntries(
        Object.entries(this.selectionCard).filter(
          ([key]) => !['meta_estrategica', 'meta_fornecedor'].includes(key)
          )
        )
        return filtered
    }
  },
  watch: {
    loadedSalesmenType: function () {
      this.getGoalsPercentage();
      this.getRealizedSales();
    },
    role: function () {
      this.users = [];
      this.user = null;
      this.checkTypeUser();
    },
    anosafra: function () {
      this.users = [];
      this.user = null;
      this.checkTypeUser();
    }
  },
};
</script>
<style>
.bg-gradient-grey {
  background: linear-gradient(87deg, #626266 0, #4c4c50 100%) !important;
  background-image: linear-gradient(
    87deg,
      rgb(74, 75, 82) 0px,
    rgb(71, 71, 71) 100%
  ) !important;
}
</style>
